import { lock, unlock } from 'tua-body-scroll-lock'
import { debounce } from '../utilities'
import { MENU_OPEN, MODAL_OPEN, SEARCH_OPEN } from '../utilities/constants'

export default class {
  constructor(el, options) {
    const navButton = el.querySelector('.js-navToggle')
    const navContainer = el.querySelector('.js-navScroll')

    navButton.addEventListener('click', () => {
      if (document.documentElement.classList.contains(MENU_OPEN)) {
        document.documentElement.classList.remove(MENU_OPEN)
        return
      }

      if (document.documentElement.classList.contains(MODAL_OPEN)) {
        document.documentElement.classList.remove(MODAL_OPEN)
        return
      }

      if (document.documentElement.classList.contains(SEARCH_OPEN)) {
        document.documentElement.classList.remove(SEARCH_OPEN)
        return
      }

      const isOpening = document.documentElement.classList.toggle(MENU_OPEN)

      if (isOpening) {
        // el.querySelector('a,input').focus({
        //   preventScroll: true,
        // })
      }
    })

    window.addEventListener('keyup', (e) => {
      if (
        e.key === 'Escape' &&
        document.documentElement.classList.contains(MENU_OPEN)
      ) {
        document.documentElement.classList.remove(MENU_OPEN)
      }
    })

    function handleResize() {
      document.documentElement.style.removeProperty('--Head-height')

      window.requestAnimationFrame(() => {
        document.documentElement.style.setProperty(
          '--Head-height',
          `${el.offsetHeight}px`,
        )
      })
    }

    window.addEventListener('resize', debounce(handleResize, 300), {
      passive: true,
    })

    handleResize()

    let prevState = document.documentElement.classList.contains(MENU_OPEN)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const isOpen = mutation.target.classList.contains(MENU_OPEN)

        if (isOpen === prevState) {
          return
        }

        if (isOpen) {
          lock(navContainer)
        } else {
          unlock(navContainer)
        }

        prevState = isOpen
      })
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }
}
